import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import Button from '@datacamp/waffles-button';
import { Select, SelectOption, TextArea } from '@datacamp/waffles-form-elements';
import { Dialog } from '@datacamp/waffles-modals';
import { Paragraph } from '@datacamp/waffles-text';
import React from 'react';
import { useTranslation } from '../useTranslation';
var optionalLabelStyle = {
  color: '#686f75',
  lineHeight: 1.25,
  position: 'absolute',
  right: 60,
  top: 28
};

var FeedbackFormInput = function FeedbackFormInput(_ref) {
  var _ref$category = _ref.category,
      category = _ref$category === void 0 ? '' : _ref$category,
      categoryOptions = _ref.categoryOptions,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$extraClassName = _ref.extraClassName,
      extraClassName = _ref$extraClassName === void 0 ? '' : _ref$extraClassName,
      _ref$feedbackMessage = _ref.feedbackMessage,
      feedbackMessage = _ref$feedbackMessage === void 0 ? '' : _ref$feedbackMessage,
      feedbackMessageError = _ref.feedbackMessageError,
      formLabel = _ref.formLabel,
      _ref$formPlaceholder = _ref.formPlaceholder,
      formPlaceholder = _ref$formPlaceholder === void 0 ? '' : _ref$formPlaceholder,
      _ref$onCategoryChange = _ref.onCategoryChange,
      onCategoryChange = _ref$onCategoryChange === void 0 ? function () {} : _ref$onCategoryChange,
      _ref$onFeedbackMessag = _ref.onFeedbackMessageChange,
      onFeedbackMessageChange = _ref$onFeedbackMessag === void 0 ? function () {} : _ref$onFeedbackMessag,
      title = _ref.title,
      onCancel = _ref.onCancel,
      _onSubmit = _ref.onSubmit,
      _ref$optionalLabel = _ref.optionalLabel,
      optionalLabel = _ref$optionalLabel === void 0 ? false : _ref$optionalLabel,
      context = _ref.context;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var getErrorMessage = function getErrorMessage() {
    if (feedbackMessageError != null) {
      return feedbackMessageError;
    }

    var exceedMaxChar = feedbackMessage.length > 1000;

    if (exceedMaxChar) {
      return t('FeedbackFormInput.exceedsMaxCharMessage');
    }

    return undefined;
  };

  return /*#__PURE__*/React.createElement("form", {
    className: extraClassName,
    onSubmit: function onSubmit(event) {
      event.preventDefault();

      _onSubmit();
    }
  }, optionalLabel && /*#__PURE__*/React.createElement("div", {
    style: optionalLabelStyle
  }, /*#__PURE__*/React.createElement("p", null, t('FeedbackFormInput.optional'))), /*#__PURE__*/React.createElement(Dialog.Header, null, title !== null && title !== void 0 ? title : t('FeedbackFormInput.title')), /*#__PURE__*/React.createElement(Dialog.Body, null, context && /*#__PURE__*/React.createElement(Paragraph, null, context), categoryOptions && /*#__PURE__*/React.createElement(Select, {
    css: {
      boxShadow: 'inset 0 0 0 2px rgb(225, 225, 232)'
    },
    dataAttributes: {
      cy: 'report-select'
    },
    id: "category",
    label: t('FeedbackFormInput.feedbackType'),
    name: "Category",
    onChange: onCategoryChange,
    value: category
  }, [/*#__PURE__*/React.createElement(SelectOption, {
    key: "",
    value: ""
  }, ' ')].concat(_toConsumableArray(categoryOptions))), /*#__PURE__*/React.createElement(TextArea, {
    css: {
      boxShadow: 'inset 0 0 0 2px rgb(225, 225, 232)'
    },
    dataAttributes: {
      cy: 'report-content'
    },
    errorMessage: getErrorMessage(),
    id: "extra-information",
    label: formLabel !== null && formLabel !== void 0 ? formLabel : t('FeedbackFormInput.feedbackMessage'),
    maxLength: 1000,
    name: "extra",
    onChange: onFeedbackMessageChange,
    placeholder: formPlaceholder,
    rows: 8,
    value: feedbackMessage
  })), /*#__PURE__*/React.createElement(Dialog.Footer, null, /*#__PURE__*/React.createElement(Button, {
    dataAttributes: {
      cy: 'modal-close'
    },
    onClick: function onClick() {
      return onCancel();
    }
  }, t('FeedbackFormInput.secondaryButton')), /*#__PURE__*/React.createElement(Button, {
    appearance: "primary",
    dataAttributes: {
      cy: 'report-submit'
    },
    disabled: disabled,
    intent: "success",
    type: "submit"
  }, t('FeedbackFormInput.primaryButton'))));
};

FeedbackFormInput.displayName = 'FeedbackForm.Input';
export default FeedbackFormInput;